import React from 'react';
import PropTypes from 'prop-types';
import { Line } from '@ant-design/charts';

export const LineChart = ({ customFormatter, customTotalFormat, aData }) => {
  return (
    <Line
      data={aData}
      className="custom-graphs"
      xField="date"
      xAxis={{
        nice: true,
        label: {
          formatter: customFormatter,
          offset: 40,
          rotate: Math.PI / 2,
          style: {
            fontSize: 11,
          },
        },
        title: {
          text: 'Días',
          offset: 85,
        },
      }}
      yField="value"
      yAxis={{
        title: {
          text: 'Cantidad',
        },
      }}
      label={{
        position: 'middle',
        style: {
          fill: '#FFFFFF',
          opacity: 0.6,
        },
      }}
      meta={{
        date: { alias: 'Fecha' },
        value: { alias: 'Cantidad' },
      }}
      point={{
        size: 3,
        shape: 'diamond',
        style: {
          fill: 'white',
          stroke: '#2593fc',
          lineWidth: 1,
        },
      }}
      tooltip={{
        customContent: (title, data) => {
          return [
            '<table class="custom-tooltip"><tbody>',
            `<tr><th>Día</th><td>${customFormatter(title)}</td></tr>`,
            `<tr><th>Cantidad</th><td>${customTotalFormat(
              data.length ? data[0].value : ''
            )}</td></tr>`,
            '</tbody></table>',
          ].join('');
        },
      }}
      renderer="svg"
    />
  );
};

LineChart.propTypes = {
  customFormatter: PropTypes.func,
  customTotalFormat: PropTypes.func,
  aData: PropTypes.array,
};
